var __WEBPACK_NAMESPACE_OBJECT__ = require("core-js/modules/web.url-search-params.js");